import { FC, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import MobilePanelConfigurationCommand from '../../../services/command/mobilepanelconfiguration/MobilePanelConfigurationCommand.services';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    refresh?: any;
}
export const SCUIMPConfigDialogV2: FC<IProps> = ({ selectedRow, open = false, onClose, refresh }) => {
    const [parameterValue, setParameterValue] = useState(selectedRow ? selectedRow?.parameter_value : '');

    const [parameterKey, setParameterKey] = useState(selectedRow ? selectedRow?.parameter_key : '');
    useEffect(() => {
        setParameterValue(selectedRow?.parameter_value === '-' ? ' ' : selectedRow?.parameter_value);
        setParameterKey(selectedRow?.parameter_key === '-' ? ' ' : selectedRow?.parameter_key);
    }, [selectedRow]);

    const handleChangeParametre_Key = (event: any) => {
        setParameterKey(event.target.value);
    };
    const handleChangeParametre_Value = (event: any) => {
        setParameterValue(event.target.value);
    };
    const countryStore: any = useSelector((state: any) => state?.country);

    const { t } = useTranslation();

    const UpdateMobilHandler = async () => {
        console.info(selectedRow);
        let params = {
            id: selectedRow.id,
            Parameter_Key: parameterKey,
            Parameter_Value: parameterValue,
        };
        if (parameterKey && parameterKey?.trim().length > 0 && parameterValue && parameterValue?.trim().length > 0) {
            MobilePanelConfigurationCommand.PutMobilePanelConfiguration(params)
                .then(() => {
                    Swal.fire(t('general.updated'), ' ', 'success');
                    refresh();
                    onClose();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const CreateMobilHandler = async () => {
        let params = {
            Parameter_Key: parameterKey,
            Parameter_Value: parameterValue,
            CountryId: countryStore.country,
        };
        if (parameterKey && parameterKey?.trim().length > 0 && parameterValue && parameterValue?.trim().length > 0) {
            MobilePanelConfigurationCommand.CreateMobilePanelConfigurationV2(params)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    refresh();
                    onClose();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const submitHandler = (event: any) => {
        event.preventDefault();
        CreateMobilHandler();
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t('mobilePanel.mobilePanelConfiguration')}</DialogTitle>
            <form onSubmit={submitHandler}>
                <DialogContent>
                    <TextField
                        label="Key"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.parameter_key}
                        onChange={handleChangeParametre_Key}
                    />
                    <TextField
                        label="Value"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.parameter_value}
                        onChange={handleChangeParametre_Value}
                    />
                </DialogContent>
                <DialogActions>
                    {selectedRow?.id ? (
                        <Button onClick={UpdateMobilHandler}>{t('general.update')}</Button>
                    ) : (
                        <Button type="submit">{t('general.save')} </Button>
                    )}
                    <Button onClick={onClose}>{t('general.cancel')} </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
